import { OrderProperty } from 'src/adminPanel/components/offsetting/orders/details/OrderPropertyDetails';
import { SortByI } from 'src/adminPanel/components/offsetting/orders/filter/SortByI';
import { SCHEMA_OFFSETTING_ORDER_FILTER_FULL_SHAPE } from 'src/adminPanel/schema/OffsettingOrderFilter';
import { CommonAddressRequestFilter } from '../CommonAddressRequestFilter';

export class OrderRequestFilter extends CommonAddressRequestFilter {
    public customerId?: number;
    public orderMandant?: string[];
    public excludeOrderMandant?: string[];
    public orderNumber?: string;
    public orderedOnFrom?: Date;
    public orderedOnTo?: Date;
    public invoiceDateFrom?: Date;
    public invoiceDateTo?: Date;
    public paymentMethods?: string[];
    public orderPaid: boolean | undefined;
    public orderVerbucht: boolean | undefined;
    public isGross: boolean | undefined;
    public totalAmountFrom?: number;
    public totalAmountTo?: number;
    public sourceDepot?: string[];
    public articleNumbers?: string[];
    public isArticleNumbersStrictMatch?: boolean;
    public logisticDeliveryCompany?: string[];
    public logisticSent: boolean | undefined;
    public logisticSentFrom?: Date;
    public logisticSentTo?: Date;
    public logisticStatusInfo?: string[];
    public targetTable?: string;
    public magicSearch?: string;
    public sortBy?: SortByI[];
    public paymentDateFrom?: Date;
    public paymentDateTo?: Date;
    public paymentAmountFrom?: number;
    public paymentAmountTo?: number;
    public orderProperties?: OrderProperty[];
    public defaultPageSize?: string;
    public orderNoteSearch?: string;
    public orderHistorySubject?: string;
    public orderHistoryDetailsSearch?: string;
    public productNameSearch?: string[];
    public productInvoiceDetailsSearch?: string[];

    constructor(json: any) {
        super(json);
        this.customerId = json.customerId || undefined;
        this.orderMandant = json.orderMandant && json.orderMandant.length > 0 ? json.orderMandant : undefined;
        this.excludeOrderMandant =
            json.excludeOrderMandant && json.excludeOrderMandant.length > 0 ? json.excludeOrderMandant : undefined;
        this.orderNumber = json.orderNumber || undefined;
        this.orderedOnFrom = json.orderedOnFrom ? new Date(json.orderedOnFrom) : undefined;
        this.orderedOnTo = json.orderedOnTo ? new Date(json.orderedOnTo) : undefined;
        this.invoiceDateFrom = json.invoiceDateFrom ? new Date(json.invoiceDateFrom) : undefined;
        this.invoiceDateTo = json.invoiceDateTo ? new Date(json.invoiceDateTo) : undefined;
        this.paymentMethods = json.paymentMethods && json.paymentMethods.length > 0 ? json.paymentMethods : undefined;
        this.orderPaid = json.orderPaid ?? undefined;
        this.orderVerbucht = json.orderVerbucht ?? undefined;
        this.isGross = json.isGross ?? undefined;
        this.totalAmountFrom = json.totalAmountFrom || undefined;
        this.totalAmountTo = json.totalAmountTo || undefined;
        this.sourceDepot = json.sourceDepot && json.sourceDepot.length > 0 ? json.sourceDepot : undefined;
        this.articleNumbers = json.articleNumbers && json.articleNumbers.length > 0 ? json.articleNumbers : undefined;
        this.isArticleNumbersStrictMatch =
            json.isArticleNumbersStrictMatch !== undefined ? json.isArticleNumbersStrictMatch : false;
        this.logisticDeliveryCompany =
            json.logisticDeliveryCompany && json.logisticDeliveryCompany.length > 0
                ? json.logisticDeliveryCompany
                : undefined;
        this.logisticSent = json.logisticSent ?? undefined;
        this.logisticSentFrom = json.logisticSentFrom ? new Date(json.logisticSentFrom) : undefined;
        this.logisticSentTo = json.logisticSentTo ? new Date(json.logisticSentTo) : undefined;
        this.logisticStatusInfo =
            json.logisticStatusInfo && json.logisticStatusInfo.length > 0 ? json.logisticStatusInfo : undefined;
        this.targetTable = json.targetTable || undefined;
        this.magicSearch = json.magicSearch;
        this.paymentDateFrom = json.paymentDateFrom ? new Date(json.paymentDateFrom) : undefined;
        this.paymentDateTo = json.paymentDateTo ? new Date(json.paymentDateTo) : undefined;
        this.paymentAmountFrom = json.paymentAmountFrom || undefined;
        this.paymentAmountTo = json.paymentAmountTo || undefined;
        this.sortBy = json.sortBy;
        this.orderProperties = json.orderProperties;
        this.defaultPageSize = json.defaultPageSize || undefined;
        this.orderNoteSearch = json.orderNoteSearch || undefined;
        this.orderHistorySubject = json.orderHistorySubject || undefined;
        this.orderHistoryDetailsSearch = json.orderHistoryDetailsSearch || undefined;
        this.productNameSearch =
            json.productNameSearch && json.productNameSearch.length > 0 ? json.productNameSearch : undefined;
        this.productInvoiceDetailsSearch =
            json.productInvoiceDetailsSearch && json.productInvoiceDetailsSearch.length > 0
                ? json.productInvoiceDetailsSearch
                : undefined;
    }

    static fromOrderFilterForm(schema: SCHEMA_OFFSETTING_ORDER_FILTER_FULL_SHAPE): OrderRequestFilter {
        const newOrderRequestFilter: OrderRequestFilter = new OrderRequestFilter(schema);

        newOrderRequestFilter.orderPaid = this.booleanValue(schema.orderPaid ?? '');
        newOrderRequestFilter.orderVerbucht = this.booleanValue(schema.orderVerbucht ?? '');
        newOrderRequestFilter.isGross = this.booleanValue(schema.isGross ?? '');
        newOrderRequestFilter.logisticSent = this.booleanValue(schema.logisticSent ?? '');
        newOrderRequestFilter.totalAmountFrom = schema.totalAmountFrom
            ? Number.parseFloat(schema.totalAmountFrom.replaceAll(',', '.'))
            : undefined;
        newOrderRequestFilter.totalAmountTo = schema.totalAmountTo
            ? Number.parseFloat(schema.totalAmountTo?.replaceAll(',', '.'))
            : undefined;
        newOrderRequestFilter.paymentAmountFrom = schema.paymentAmountFrom
            ? Number.parseFloat(schema.paymentAmountFrom.replaceAll(',', '.'))
            : undefined;
        newOrderRequestFilter.paymentAmountTo = schema.paymentAmountTo
            ? Number.parseFloat(schema.paymentAmountTo?.replaceAll(',', '.'))
            : undefined;

        if (schema.articleNumbers) {
            const newArticleNumbers: string[] = [];
            schema.articleNumbers?.forEach(art => newArticleNumbers.push(art['value']));
            newOrderRequestFilter.articleNumbers = newArticleNumbers;
        }
        newOrderRequestFilter.isArticleNumbersStrictMatch = schema.isArticleNumbersStrictMatch;
        newOrderRequestFilter.orderProperties = schema.orderProperties;
        newOrderRequestFilter.defaultPageSize = schema.defaultPageSize;

        if (schema.productNameSearch) {
            const terms: string[] = [];
            schema.productNameSearch?.forEach(item => terms.push(item['value']));
            newOrderRequestFilter.productNameSearch = terms.length > 0 ? terms : undefined;
        }
        if (schema.productInvoiceDetailsSearch) {
            const terms: string[] = [];
            schema.productInvoiceDetailsSearch?.forEach(item => terms.push(item['value']));
            newOrderRequestFilter.productInvoiceDetailsSearch = terms.length > 0 ? terms : undefined;
        }
        newOrderRequestFilter.orderNoteSearch = schema.orderNoteSearch || undefined;
        newOrderRequestFilter.orderHistorySubject = schema.orderHistorySubject || undefined;
        newOrderRequestFilter.orderHistoryDetailsSearch = schema.orderHistoryDetailsSearch || undefined;

        return newOrderRequestFilter;
    }

    static booleanValue = (stringBool: string) => {
        switch (stringBool) {
            case 'true':
                return true;
            case 'false':
                return false;
            default:
                return undefined;
        }
    };

    static toOrderFilterForm(orderRequestFilter: OrderRequestFilter) {
        const newSchema: SCHEMA_OFFSETTING_ORDER_FILTER_FULL_SHAPE = {};

        newSchema.addressCity = orderRequestFilter.addressCity;
        newSchema.addressCountryIso2 = orderRequestFilter.addressCountryIso2;

        newSchema.addressLookupIn = orderRequestFilter.addressLookupIn;

        const newArtNumArray: Record<string, string>[] = [];
        orderRequestFilter.articleNumbers?.forEach((artN, index) => newArtNumArray.push({ value: artN.toString() }));
        newSchema.articleNumbers = newArtNumArray;
        newSchema.isArticleNumbersStrictMatch = orderRequestFilter.isArticleNumbersStrictMatch;

        newSchema.logisticStatusInfo = orderRequestFilter.logisticStatusInfo;

        newSchema.addressName = orderRequestFilter.addressName;
        newSchema.addressPostalCode = orderRequestFilter.addressPostalCode;
        newSchema.addressStreet = orderRequestFilter.addressStreet;
        newSchema.addressStreetNumber = orderRequestFilter.addressStreetNumber;

        newSchema.customerId = orderRequestFilter.customerId?.toString();

        newSchema.isGross = orderRequestFilter.isGross?.toString() ?? '';
        newSchema.logisticDeliveryCompany = orderRequestFilter.logisticDeliveryCompany;
        newSchema.logisticSent = orderRequestFilter.logisticSent?.toString() ?? '';
        newSchema.logisticSentFrom = orderRequestFilter.logisticSentFrom
            ? new Date(orderRequestFilter.logisticSentFrom)
            : undefined;
        newSchema.logisticSentTo = orderRequestFilter.logisticSentTo
            ? new Date(orderRequestFilter.logisticSentTo)
            : undefined;

        newSchema.orderMandant = orderRequestFilter.orderMandant;
        newSchema.excludeOrderMandant = orderRequestFilter.excludeOrderMandant;
        newSchema.orderNumber = orderRequestFilter.orderNumber;
        newSchema.orderPaid = orderRequestFilter.orderPaid?.toString() ?? '';
        newSchema.orderVerbucht = orderRequestFilter.orderVerbucht?.toString() ?? '';

        newSchema.orderedOnFrom = orderRequestFilter.orderedOnFrom
            ? new Date(orderRequestFilter.orderedOnFrom)
            : undefined;
        newSchema.orderedOnTo = orderRequestFilter.orderedOnTo ? new Date(orderRequestFilter.orderedOnTo) : undefined;
        newSchema.invoiceDateFrom = orderRequestFilter.invoiceDateFrom
            ? new Date(orderRequestFilter.invoiceDateFrom)
            : undefined;
        newSchema.invoiceDateTo = orderRequestFilter.invoiceDateTo
            ? new Date(orderRequestFilter.invoiceDateTo)
            : undefined;
        newSchema.paymentDateFrom = orderRequestFilter.paymentDateFrom
            ? new Date(orderRequestFilter.paymentDateFrom)
            : undefined;
        newSchema.paymentDateTo = orderRequestFilter.paymentDateTo
            ? new Date(orderRequestFilter.paymentDateTo)
            : undefined;
        newSchema.paymentMethods = orderRequestFilter.paymentMethods;
        newSchema.sourceDepot = orderRequestFilter.sourceDepot;
        newSchema.totalAmountFrom = orderRequestFilter.totalAmountFrom?.toString();
        newSchema.totalAmountTo = orderRequestFilter.totalAmountTo?.toString();
        newSchema.targetTable = orderRequestFilter.targetTable;
        newSchema.paymentAmountFrom = orderRequestFilter.paymentAmountFrom?.toString();
        newSchema.paymentAmountTo = orderRequestFilter.paymentAmountTo?.toString();
        newSchema.sortBy = orderRequestFilter.sortBy
            ? orderRequestFilter.sortBy.map(sortItem => ({
                  order: this.getStringValue(sortItem.order),
                  property: this.getStringValue((sortItem as any).property),
                  direction: this.getStringValue((sortItem as any).direction),
              }))
            : undefined;
        newSchema.orderProperties = orderRequestFilter.orderProperties ? orderRequestFilter.orderProperties : undefined;
        newSchema.defaultPageSize = orderRequestFilter.defaultPageSize ? orderRequestFilter.defaultPageSize : undefined;

        const newProductNameArray: Record<string, string>[] = [];
        orderRequestFilter.productNameSearch?.forEach(term => newProductNameArray.push({ value: term }));
        newSchema.productNameSearch = newProductNameArray.length > 0 ? newProductNameArray : undefined;

        const newProductInvoiceDetailsArray: Record<string, string>[] = [];
        orderRequestFilter.productInvoiceDetailsSearch?.forEach(term =>
            newProductInvoiceDetailsArray.push({ value: term })
        );
        newSchema.productInvoiceDetailsSearch =
            newProductInvoiceDetailsArray.length > 0 ? newProductInvoiceDetailsArray : undefined;

        newSchema.orderNoteSearch = orderRequestFilter.orderNoteSearch;
        newSchema.orderHistorySubject = orderRequestFilter.orderHistorySubject;
        newSchema.orderHistoryDetailsSearch = orderRequestFilter.orderHistoryDetailsSearch;

        return newSchema;
    }

    private static getStringValue(input: any): string {
        return input !== undefined && input !== null ? input.toString() : '';
    }
}
